import { useUIStore } from "@/stores/uiStore";

export function useReadOnly(propsReadOnly?: boolean | undefined) {
  const pageMode = useUIStore((state) => state.pageMode);

  if (pageMode === "view" && propsReadOnly === undefined) {
    return true;
  }
  return propsReadOnly;
}
